import DOMPurify from 'dompurify';

/**
 * Sanitizes admin-authored rich text before it's rendered via
 * dangerouslySetInnerHTML. The backend also sanitizes on write; this is
 * defense-in-depth against anything that reaches the client unsanitized
 * (e.g. content saved before the backend sanitizer was added).
 */
export const sanitizeHtml = (html: string): string => DOMPurify.sanitize(html);
